import RubyMasterChat from "@/components/ruby-ai-v2/RubyMasterChat";

const RubyAIssistV2 = () => {
  return <RubyMasterChat />;
};

export default RubyAIssistV2;
